export enum IPlatform {
  DESKTOP = 'Desktop',
  MOBILE = 'MobileWeb'
}
